Object.defineProperty(exports, "__esModule", { value: true });
var natura_light_1 = require("./themes/natura/natura-light");
var natura_dark_1 = require("./themes/natura/natura-dark");
var natura_v3_light_1 = require("./themes/natura_v3/natura_v3-light");
var natura_v3_dark_1 = require("./themes/natura_v3/natura_v3-dark");
var avon_light_1 = require("./themes/avon/avon-light");
var avon_dark_1 = require("./themes/avon/avon-dark");
var avon_v2_light_1 = require("./themes/avon_v2/avon_v2-light");
var avon_v2_dark_1 = require("./themes/avon_v2/avon_v2-dark");
var the_body_shop_light_1 = require("./themes/theBodyShop/the-body-shop-light");
var the_body_shop_dark_1 = require("./themes/theBodyShop/the-body-shop-dark");
var aesop_light_1 = require("./themes/aesop/aesop-light");
var aesop_dark_1 = require("./themes/aesop/aesop-dark");
var biome_light_1 = require("./themes/biome/biome-light");
var biome_dark_1 = require("./themes/biome/biome-dark");
exports.default = {
    avon: {
        dark: avon_dark_1.avonDark,
        light: avon_light_1.avonLight
    },
    avon_v2: {
        dark: avon_v2_dark_1.avonV2Dark,
        light: avon_v2_light_1.avonV2Light
    },
    natura: {
        dark: natura_dark_1.naturaDark,
        light: natura_light_1.naturaLight
    },
    natura_v3: {
        dark: natura_v3_dark_1.naturaV3Dark,
        light: natura_v3_light_1.naturaV3Light
    },
    theBodyShop: {
        dark: the_body_shop_dark_1.theBodyShopDark,
        light: the_body_shop_light_1.theBodyShopLight
    },
    aesop: {
        dark: aesop_dark_1.aesopDark,
        light: aesop_light_1.aesopLight
    },
    biome: {
        dark: biome_dark_1.biomeDark,
        light: biome_light_1.biomeLight
    }
};
//# sourceMappingURL=themes.js.map